import autosize from 'autosize'
import Vue from 'vue'

Vue.directive('autosize', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    autosize(el)
  }
})
